export const Userdata = (userdata) => {
  return {
    type: "USER_DATA",
    data: userdata,
  };
};


export const SetContactInfo = (data) => {
  return {
    type: "CONTACT_INFO",
    contactInfo: data,
  };
};


export const LoaderStatus = (data) => {
  return {
    type: "LOADER_STATUS",
    isLoading: data,
  };
};

export const Disability = (data) => {
  return {
    type: "DISABILITY_CATEGORY",
    disability: data,
  };
};
export const SubCategory = (data) => {
  return {
    type: "HEADER_SUB_CATEGORY",
    subcategory: data,
  };
};

export const CategoryData = (data) => {
  return {
    type: "HEADER_CATEGORY",
    category: data,
  };
};

export const SetAccessToken = (data) => {
  return {
    type: "ACCESS_TOKEN",
    AccessToken: data,
  };
};

export const SetCartData = (data) => {
  return {
    type: "USER_CART",
    cartContents: data,
  };
};

export const setCartUpdated = (data) => {
  return {
    type: "USER_CART_STATUS",
    cartStatus: data,
  };
};

export const setTransactionLoad = (data) => {
  return {
    type: "USER_TRANSACTION_STATUS",
    transaction: data,
  };
};

export const setOrderCms = (data) => {
  return {
    type: "USER_ORDER_CMS",
    ordercmsData: data,
  };
};

export const setWalletCms = (data) => {
  return {
    type: "USER_WALLET_CMS",
    walletCMSData: data,
  };
};

export const SetHomePageCms = (data) => {
  return {
    type: "HOME_PAGE_CMS",
    HomeCMSData: data,
  };
};

export const SuccessModalShow = (data) => {
  return {
    type: "SUCCESS_MODAL_SHOW",
    Successmodal: data,
  };
};

export const PaymentModalShow = (data) => {
  return {
    type: "PAYMENT_MODAL_SHOW",
    PaymentModal: data,
  };
};

export const FailureModalShow = (data) => {
  return {
    type: "FAILURE_MODAL_SHOW",
    FailureModal: data,
  };
};
export const aboutCMSData = (data) => {
  return {
    type: "ABOUT_CMS_DATA",
    aboutCMS: data,
  };
};
export const CategoryStore = (data) => {
  return {
    type: "CATEGORY_STORE",
    Categories: data,
  };
};
export const CreateListingData = (data) => {
  return {
    type: "CREATE_LISTING_CATEGORY",
    createListingCategory: data,
  };
};

export const CreateListingSearch = (data) => {
  return {
    type: "CREATE_LISTING_SEARCH",
    SearchData: data,
  };
};

export const handleCSRData = (data) => {
  return {
    type: "CSR_DATA",
    csrData: data,
  };
};

export const handleISRData = (data) => {
  return {
    type: "ISR_DATA",
    isrData: data,
  };
};

export const handleBENE_UserData = (data) => {
  return {
    type: "BENEFITIORY_USER_DATA",
    beneuserData: data,
  };
};

export const handleBENE_Wishlist = (data) => {
  return {
    type: "BENEFITIORY_WISHLIST_DATA",
    beneuserWishlist: data,
  };
};

export const handleEndorse_UserData = (data) => {
  return {
    type: "ENDORSE_USER_DATA",
    endorseuserData: data,
  };
};

export const setActiveTab = (data) => {
  return {
    type: "SET_ACTIVE_TAB",
    activeTab: data,
  };
};

export const handleGoodwillData = (data) => {
  return {
    type: "GOODWILL_DATA",
    data: data,
  };
};

export const RelatedServiceData = (data) => {
  return {
    type: "RELATED_SERVICE_DATA",
    relatedServiceData: data,
  };
};

export const changeProgressOrder = (data) => {
  return {
    type: "CHANGE_PROGRESS_ORDER",
    isprogressOrder: data,
  };
};

export const AccountUpdateStatus = (data) => {
  return {
    type: "ACCOUNT_UPDATE_STATUS",
    accountUpdated: data,
  };
};
export const collectionDatalist = (data) => {
  return {
    type: "collection_Data",
    collectionData: data,
  };
};

export const handleVerifyEmail = (data) => {
  return {
    type: "VERIFY_EMAIL",
    data: data,
  };
};

export const handleBenefitaryListing = (data) => {
  return {
    type: "BENEFITARY_LISTING",
    data: data,
  };
};

export const handleBenefitaryListingPagenumber = () => {
  return {
    type: "BENEFITARY_PAGE_NUMBER",
  };
};

export const UpdateCart = (data) => {
  return {
    type: "CART_UPDATE",
    cartData: data,
  };
};

export const DealsData = (data) => {
  return {
    type: "DEALS_VALUE",
    dealsData: data,
  };
};

export const SearchCategoryData = (data) => {
  return {
    type: "SEARCH_CATEGORY_DATA",
    categoryData: data,
  };
};

export const SetCategoryUpdated = (data) => {
  return {
    type: "SET_CATEGORY_UPDATED",
    categoryUpdated: data,
  };
};

export const SetHeaderValue = (data) => {
  return {
    type: "HEADER_VALUE",
    HeaderValue: data,
  };
};

export const SetRelatedService = (data) => {
  return {
    type: "SET_RELATEDSERVICE_DATA",
    serviceValue: data,
  };
};

export const handleBankListData = (data) => {
  return {
    type: "BANK_LIST",
    data: data,
  };
};

export const BeneficiaryMasterListing = (data) => {
  return {
    type: "BENEFICIARY_MASTER_DATA",
    data: data,
  };
};

export const BeneficiaryPageNumber = (page) => {
  return {
    type: "BENEFICIARY_PAGE_NUMBER",
    data: page,
  };
};

export const updateSEOMETA = (data) => {
  return {
    type: "UPDATE_SEO_META",
    SEOMeta: data,
  };
};

export const SeoLoaderStatus = (data) => {
  return {
    type: "SEO_LOADER_STATUS",
    isLoaderStatus: data,
  };
};

export const handleSignout = (data) => {
  return {
    type: "IS_SIGNOUT_CLICKED",
    data: data,
  };
};
